import { apiUrls } from 'sdk/api-urls'
import { BaseApi } from '../base.api'
import { CityViewModel, PaginatedApiResponseModel, PaginationFilterModel } from 'sdk/models'

export class CityApi extends BaseApi {
  public getAllCities(filter: PaginationFilterModel) {
    return this.GET_Request<PaginatedApiResponseModel<CityViewModel>>(apiUrls.city.getCities(filter))
  }
  public uploadCities(file: File) {
    const formData = new FormData()
    formData.append('File', file)
    return this.POST_FormDataRequestAsync(apiUrls.city.uploadNew(), formData)
  }
}
